import React from "react";
import PropTypes from "prop-types";
import Select from "components/shared/Select";
import helpers from "helpers/base";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const shortMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

class CiteThisPage extends React.Component {
  static propTypes = {
    copyStatus: PropTypes.string
  };

  static defaultProps = {
    copyStatus: "Copy to Clipboard"
  };

  constructor(props) {
    super(props);
    // eslint-disable-next-line prefer-destructuring
    this.initialType = Object.keys(props.howToCite)[0];
    this.state = {
      selectedType: this.initialType,
      selectedValue: this.getHowToCiteWithCurrentDate(this.initialType)
    };
  }

  onChange(option) {
    this.setState({
      selectedType: option.value,
      selectedValue: this.getHowToCiteWithCurrentDate(option.value)
    });
  }

  // updates accessed date in case it's cached or doesn't match user's time zone
  getHowToCiteWithCurrentDate(type) {
    const value = this.props.howToCite[type];

    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    let regex = null;
    let replacementStr = null;

    if (type === "mla") {
      regex = /Web\. \d{1,2} \w+ \d{4}/;
      replacementStr = `Web. ${day} ${shortMonths[month]} ${year}`;
    } else if (type === "chicago") {
      regex = /Retrieved \w+ \d{1,2}, \d{4}/;
      replacementStr = `Retrieved ${months[month]} ${day}, ${year}`;
    }

    if (regex && replacementStr) {
      value.citable = value.citable.replace(regex, replacementStr);
      value.strippedCitable = value.strippedCitable.replace(
        regex,
        replacementStr
      );
    }

    return value;
  }

  copyCitation() {
    let { copyStatus } = this.props;
    try {
      const $textarea = $(this._textarea);
      $textarea.show();
      $textarea[0].focus();
      $textarea[0].select();
      document.execCommand("copy");
      $textarea.blur();
      $textarea.hide();
      copyStatus = "Copied!";
    } catch (_e) {
      copyStatus = "Error!";
    } finally {
      $(this._btn).focus(); // return focus to copy button
      const $copyText = $(this._copyText)
        .text(copyStatus)
        .delay(1000)
        .fadeOut(() => {
          $copyText.text(this.props.copyStatus).show();
        });
    }
  }

  render() {
    const { howToCite } = this.props;
    const options = helpers.object.map(howToCite, (k, v) => {
      return { label: v.title, value: k };
    });
    return (
      <div>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Cite This Page</div>
            </div>
            <div className="modal-body">
              <div className="cite-this-page__header">
                Choose citation style:
              </div>
              <div className="form-group">
                <Select
                  id="cite-this-page__select"
                  name="cite-this-page__select"
                  value={this.initialType}
                  options={options}
                  onChange={(value) => this.onChange(value)}
                />
              </div>
              <div className="form-group">
                <div
                  className={`cite-this-page__citation ${this.state.selectedType}`}
                >
                  <div
                    className="well"
                    dangerouslySetInnerHTML={{
                      __html: this.state.selectedValue.citable
                    }}
                  />
                  <textarea
                    ref={(textarea) => {
                      this._textarea = textarea;
                    }}
                    value={this.state.selectedValue.strippedCitable}
                    readOnly
                  />
                </div>
              </div>
              <div className="text-center">
                <button
                  id="cite-this-page__button--copy"
                  className="btn btn-primary btn-lg"
                  ref={(_btn) => this._btn}
                  onClick={() => this.copyCitation()}
                  type="button"
                >
                  <span
                    className="cite-this-page__copy--text"
                    ref={(copyText) => {
                      this._copyText = copyText;
                    }}
                  >
                    {this.props.copyStatus}
                  </span>
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-default btn-md"
                data-dismiss="modal"
                type="button"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CiteThisPage;
